import { WorkspaceSkillOfferingRead } from "../common/types";
import { IntegrationCatalogEntry } from "../types/integrationCatalog";
import { isIntegrationEnabledForOrg } from "./agentSkillStoreRequirements";

const requirementAllowsPickerRender = (
  integrationKey: string,
  catalogEntries: IntegrationCatalogEntry[],
) => {
  const entry = catalogEntries.find(
    (candidate) => candidate.key === integrationKey,
  );
  if (!entry) {
    return true;
  }
  return isIntegrationEnabledForOrg(entry);
};

const skillRequirementsAllowPickerRender = (
  requiredIntegrations: string[],
  catalogEntries: IntegrationCatalogEntry[],
) =>
  requiredIntegrations.every((integrationKey) =>
    requirementAllowsPickerRender(integrationKey, catalogEntries),
  );

export const filterWorkspaceSkillOfferingsByIntegrations = (
  offerings: WorkspaceSkillOfferingRead[],
  catalogEntries: IntegrationCatalogEntry[],
): WorkspaceSkillOfferingRead[] => {
  if (!catalogEntries.length) {
    return offerings;
  }

  return offerings
    .map((offering) => {
      const skillRequirements = offering.skill_requirements || {};
      const visibleSkillKeys = offering.skill_keys.filter((skillKey) =>
        skillRequirementsAllowPickerRender(
          skillRequirements[skillKey] || [],
          catalogEntries,
        ),
      );
      return {
        ...offering,
        skill_keys: visibleSkillKeys,
      };
    })
    .filter((offering) => offering.skill_keys.length > 0);
};
